import { sortBy } from 'lodash';

import { QuickLinkViewItem } from '../models';

export const orderQuickLinkViewItems = (
  quickLinkViewItems: QuickLinkViewItem[],
  quickLinksOrder: string[],
): QuickLinkViewItem[] => {
  if (quickLinksOrder.length) {
    return sortBy(quickLinkViewItems, (link) =>
      quickLinksOrder.indexOf(link.id),
    );
  }

  return quickLinkViewItems;
};

export const filterVisibleQuickLinkViewItems = (
  quickLinkViewItems: QuickLinkViewItem[],
): QuickLinkViewItem[] => quickLinkViewItems.filter((link) => link.active);

export const orderAndFilterVisibleQuickLinkViewItems = (
  quickLinkViewItems: QuickLinkViewItem[],
  quickLinksOrder: string[],
): QuickLinkViewItem[] =>
  filterVisibleQuickLinkViewItems(
    orderQuickLinkViewItems(quickLinkViewItems, quickLinksOrder),
  );
